// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N200 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { Flex } from '@atlassian/eoc-flex';

const commonStyles = css({
	font: token('font.body.UNSAFE_small'),
	marginTop: token('space.050', '4px'),
	justifyContent: 'baseline',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const StyledErrorMessage = styled(Flex)(commonStyles, {
	color: token('color.text.danger', '#AE2A19'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const StyledValidMessage = styled(Flex)(commonStyles, {
	color: token('color.text.success', '#216E4E'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const StyledHelperMessage = styled(Flex)(commonStyles, {
	color: token('color.text.subtlest', N200),
});
